import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ShapedButton from './ShapedButton';
import OkIcon from '../../images/vector/ok-btn.svg';

const GoButtonDark = ({ ariaLabel, className, text, onClick, isEnabled, isPulsating }) => (
    <div className="go-button-dark">
        <ShapedButton
            ariaLabel={ariaLabel}
            styles={classNames('go-button-dark-wrapper', className, {
                isPulsating,
                disabled: !isEnabled,
            })}
            text={text}
            onClick={onClick}
            isEnabled={isEnabled}
        >
            <OkIcon className="svg-button-dark" />
        </ShapedButton>
    </div>
);

GoButtonDark.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    isEnabled: PropTypes.bool,
    isPulsating: PropTypes.bool,
};

GoButtonDark.defaultProps = {
    ariaLabel: '',
    text: '',
    className: '',
    isEnabled: true,
    isPulsating: false,
};

export default GoButtonDark;
